import { Link } from 'react-router-dom';

interface CategoryCardProps {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export default function CategoryCard({ name, slug, icon, count }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col items-center gap-3 p-4 rounded-xl bg-background-200/60 hover:bg-background-200 transition-all duration-300 cursor-pointer"
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-foreground-950 transition-all duration-300">
        <i className={`${icon} text-xl`}></i>
      </div>
      <span className="text-foreground-700 text-sm font-medium whitespace-nowrap group-hover:text-foreground-950 transition-colors duration-200">
        {name}
      </span>
      <span className="text-foreground-400 text-xs whitespace-nowrap">{count} 部影片</span>
    </Link>
  );
}